export const ASSISTANT_ENDPOINT = '/c/v1/chat/assistant/init';
export const ASSISTANT_DEFLECTION_ENDPOINT =
  '/c/v2/chat/assistant/sessions/:id/deflections';
